import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";
import { UUID } from "crypto";

export default class APIUnits extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  getUnits = async (): Promise<types.UnitResponse[]> => {
    let res = await this._fetch({
      url: `/units/`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  // Alias for getUnits for consistency with other API clients
  get = async (): Promise<types.UnitResponse[]> => {
    return this.getUnits();
  };

  // Additional alias for consistency with naming conventions
  list = async (): Promise<types.UnitResponse[]> => {
    return this.getUnits();
  };

  getUnitById = async (unitId: UUID): Promise<types.UnitResponse> => {
    let res = await this._fetch({
      url: `/units/${unitId}`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  putUnitId = async (
    unitId: UUID,
    { ...body }: types.UnitUpdateRequest,
  ): Promise<types.UnitResponse> => {
    let res = await this._fetch({
      url: `/units/${unitId}`,
      method: "PUT",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  deleteUnitId = async (unitId: UUID): Promise<void> => {
    await this._fetch({
      url: `/units/${unitId}`,
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
  };

  postUnits = async ({
    ...body
  }: types.UnitCreateRequest): Promise<types.UnitResponse> => {
    let res = await this._fetch({
      url: `/units/`,
      method: "POST",
      body: body,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
